export type PlaceholderReplacements = Readonly<Record<string, string | null | undefined>>;

/** Replace Payload rich-text placeholders in the form `{{ key }}`. */
export function replacePlaceholders(text: string, replacements: PlaceholderReplacements): string {
	const entries = Object.entries(replacements).filter(
		([, value]) => value !== undefined && value !== null && value !== '',
	);
	if (entries.length === 0) return text;

	const patterns = entries.map(([key]) => {
		const escapedKey = escapeRegExp(key);
		return `\\{\\{\\s*${escapedKey}\\s*\\}\\}`;
	});
	const pattern = new RegExp(patterns.join('|'), 'g');

	return text.replace(pattern, (match) => {
		const replacement = entries.find(([key]) => {
			const escapedKey = escapeRegExp(key);
			return new RegExp(`^\\{\\{\\s*${escapedKey}\\s*\\}\\}$`).test(match);
		});

		return replacement?.[1] ?? match;
	});
}

function escapeRegExp(value: string) {
	return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
